import { render, staticRenderFns } from "./itemConfiguration.vue?vue&type=template&id=53c3ee22"
import script from "./itemConfiguration.vue?vue&type=script&lang=ts"
export * from "./itemConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconItemColor: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconItemColor.vue').default,HtmlBrandButton: require('/codebuild/output/src3458403893/src/acredo-website/components/html/htmlBrandButton.vue').default})
